import { useCallback, useState } from 'react';
import { toast } from 'sonner';
import { isNotFoundError, showApiErrorToast } from '@/utils/errors';
import { downloadDerAttachment } from '../api/billing.api';
import type { OfflineDerRow } from '../types/billing.types';

export function useDerBillDownload() {
  const [downloadingDetailId, setDownloadingDetailId] = useState<number | null>(null);

  const downloadBill = useCallback(async (row: OfflineDerRow) => {
    setDownloadingDetailId(row.detailId);
    try {
      await downloadDerAttachment(row.detailId, row.fileName ?? `bill-${row.detailId}`);
    } catch (downloadError) {
      if (isNotFoundError(downloadError)) {
        toast.error('Bill not available', {
          description: "This bill's file has not been added yet.",
        });
        return;
      }
      showApiErrorToast(downloadError, 'Could not open the bill');
    } finally {
      setDownloadingDetailId(null);
    }
  }, []);

  return { downloadingDetailId, downloadBill };
}
